export const RESERVED = 'Reserved';
export const CONFIRMED = 'Confirmed';
export const UPDATED = 'Updated';
export const CANCELED = 'Canceled';
export const NO_SHOW = 'No Show';
export const NO_SHOW_AS_STATE = 'Noshow';
export const SEATED = 'Seated';

export type BookingStatus =
  | typeof CONFIRMED
  | typeof UPDATED
  | typeof CANCELED
  | typeof RESERVED
  | typeof NO_SHOW
  | typeof SEATED;

export const BookingState = {
  ACTIVE: 'Active',
  CANCELED: 'Canceled',
  DELETED: 'Deleted',
  PENDING: 'Pending',
  SEATED: 'Seated',
  NO_SHOW: 'Noshow'
};

export const BookingType = {
  RESERVATION: 'Reservation',
  WALKIN: 'Walkin',
  WAITPARTY: 'Waitparty'
};
